module.exports = __webpack_public_path__ + "assets/images/card-pg-7_ef659f56c415ec3eb452b5a5d2c9ccfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-7.png
// module id = 194
// module chunks = 0